import { Box, Card, Text, useToggle } from '@factorialco/deprecated-design-system'

import { useIncidenceFilterContext } from 'modules/bookkeepers/lib/IncidenceFilterContext'

import StatsTooltip, { IncidenceTypeStats } from './Tooltip'

interface Props {
  name: string
  value: number | null | undefined
  typeStats: IncidenceTypeStats | undefined
}

const StatBlock = ({ name, value, typeStats }: Props) => {
  const { filters } = useIncidenceFilterContext()
  const [open, toggle] = useToggle(false)
  const numberIncidencePerStatus = value || 0
  const showTooltip = filters.name === undefined && numberIncidencePerStatus > 0

  return (
    <Card>
      <Card.Content>
        <Box>
          <Text.Normal color="grey1000" weight="medium" size="200" ellipsis>
            {name}
          </Text.Normal>
        </Box>
        <Box flexDirection="row" alignItems="center">
          <Text color="grey1000" weight="semibold" size="500">
            {numberIncidencePerStatus}
          </Text>
          {showTooltip && (
            <Box justifyContent="spaceAround">
              <StatsTooltip stats={typeStats} toggle={toggle} open={open} />
            </Box>
          )}
        </Box>
      </Card.Content>
    </Card>
  )
}

export default StatBlock
